import Combobox, { MenuItem } from '@ingka/combobox';
import React, { useState } from 'react';
import InputField from '@ingka/input-field';
import FormField from '@ingka/form-field';
import styled from 'styled-components';
import { contentDelimiterStyles } from 'components/layout';
import Tabs, { Tab, TabPanel } from '@ingka/tabs';
import RadioButtonGroup from '@ingka/radio-button-group';

const MainDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  justify-content: space-between;
`;
const SecondDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  justify-content: space-between;
`;
const tabs = [<Tab key="tab-3" text={'Products'} tabPanelId="tab_3" />];
const tabPanels = [<TabPanel key="tab-3" tabPanelId="tab_3" title="Product Name[GTIN]" />];

const RadioButtonsArray = [
  {
    id: 'GTINRadio',
    name: 'groupRadios',
    label: 'GTIN number',
    value: 'ON',
    disabled: false,
    checked: true,
  },
  {
    id: 'secondRadio',
    name: 'groupRadios',
    label: 'Article Number',
    value: 'OFF',
    disabled: false,
  },
];

export const ManualEntry = () => {
  const [ddsVerification, setDdsVerification] = useState('');
  const [ddsNumber, setDdsNumber] = useState('');
  const [productName, setProductName] = useState('');
  const [shouldValidate, setShouldValidate] = useState(false);
  const [valid, setValid] = useState(false);
  // const formfieldProps = {
  //   fieldHelper: {
  //     link: 'https://www.ikea.com',
  //     linkText: 'Some link text',
  //     msg: 'Some information message about usage of formfield',
  //   },
  //   validation: {
  //     link: 'https://www.ikea.com',
  //     linkText: 'Some link text',
  //     msg: 'Some error message for how checkbox should be ticked',
  //   },
  //   shouldValidate,
  //   valid,
  // };
  return (
    <FormField
    // {...formfieldProps}
    // characterLimit={0}
    // fieldHelper={{
    //   id: 'helper-msg-id',
    //   // msg: 'Field helper msg text',
    //   type: '',
    // }}
    // valid="error"
    // validation={{
    //   id: 'error-msg-id',
    //   msg: 'Validation msg text',
    //   type: 'error',
    // }}
    >
      <MainDiv>
        <Combobox
          clearButtonLabel="Clear selected items"
          labelId="label-id"
          listboxId="combobox-listbox"
          placeholder="Supplier"
          label="Supplier"
        >
          <MenuItem id="option-1" title="First option!" />
          <MenuItem id="option-2" title="Second option!" />
        </Combobox>

        <InputField
          label="DDS reference number"
          iconPosition="leading"
          id="example-id"
          type="number"
          style={{ marginRight: 10 }}
          value={ddsNumber}
          onChange={(e) => {
            setDdsNumber(e.target.value);
          }}
        />
        <InputField
          style={{ marginRight: 10 }}
          label="DDS verification number"
          iconPosition="leading"
          id="example-id"
          type="number"
          value={ddsVerification}
          onChange={(e) => {
            setDdsVerification(e.target.value);
          }}
        />
        <InputField
          style={{ marginRight: 10 }}
          label="DDS filing date"
          iconPosition="leading"
          id="date"
          prefixLabel="Prefix label"
          suffixLabel="Suffix label"
          type="number"
        />
      </MainDiv>

      <Tabs tabs={tabs} tabPanels={tabPanels} ariaLabel="Example Tabs Label" />
      <SecondDiv>
        <InputField
          style={{ marginRight: 10 }}
          iconPosition="leading"
          id="example-id"
          type="text"
          value={productName}
          onChange={(e) => {
            setProductName(e.target.value);
          }}
        />
        <RadioButtonGroup list={RadioButtonsArray} />
        <InputField
          style={{ marginRight: 10 }}
          iconPosition="leading"
          id="example-id"
          type="text"
          value={productName}
        />
      </SecondDiv>

      <Tabs tabs={tabs} tabPanels={tabPanels} ariaLabel="Example Tabs Label" />
      <SecondDiv>
        <Combobox
          clearButtonLabel="Clear selected items"
          labelId="label-id"
          listboxId="combobox-listbox"
          placeholder="HS Heading"
        >
          <MenuItem id="option-1" title="First option!" />
          <MenuItem id="option-2" title="Second option!" />
        </Combobox>
        <InputField
          style={{ marginRight: 10 }}
          iconPosition="leading"
          id="example-id"
          type="text"
          value={productName}
          onChange={(e) => {
            setProductName(e.target.value);
          }}
        />
        <InputField
          style={{ marginRight: 10 }}
          iconPosition="leading"
          id="example-id"
          type="text"
          value={productName}
        />
      </SecondDiv>
    </FormField>
  );
};
